import React, { useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaDownload } from "react-icons/fa6";

const AddCounceller = () => {
  const [statuses, setStatuses] = useState(['']);

  const handleAddStatus = () => {
    setStatuses([...statuses, '']);
  };

  const handleStatusChange = (index, value) => {
    const updatedStatuses = [...statuses];
    updatedStatuses[index] = value;
    setStatuses(updatedStatuses);
  };

 const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container py-4">
      {/* Add Country Section */}
     <div className='d-flex align-items-center justify-content-center'>
         <div className="fs-2 px-3 py-2 mb-2 text-center bg-dark text-white">
          Counsellor Information
        </div>
     </div>
      <div className="card mb-4 shadow-sm">
        
        <div className="card-body row">
          <div className="mb-3 col-md-6 col-12">
            <label>Name</label>
            <input type="text" className="form-control" />
          </div>
            <div className="col-md-6 col-12 mb-3">
            <label>Phone No</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-6 col-12 mb-3">
            <label>Mobile</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-6 col-12 mb-3">
            <label>Download CSV</label>
            <button className="form-control btn btn-lg  text-end text-primary"> <FaDownload /></button>
          </div>
         
        </div>
      </div>







<div className='d-flex align-items-center mt-3 justify-content-center'>
         <div className="fs-2 px-4 py-2 mb-2 text-center bg-dark text-white">
           Login Details
        </div>
     </div>

  <div className="card shadow-sm">
        <div className="card-body row">
          <div className="col-md-12 col-12 mb-3">
            <label>Email</label>
            <input type="email" className="form-control" />
            </div>

 <div className="col-md-12 col-12 mb-3">
      <label>Password</label>
      <div className="input-group">
        <div className="input-group-append">
          <button
            className="btn btn-lg p-3 borderingbutton btn-outline-primary"
            type="button"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
        />
        
      </div>
    </div>
          


        

          <div className="d-flex gap-2 pt-3 pb-3">
  <button type="submit" className="btn btn-primary">Submit</button>
</div>

          <div className="mt-3">
            <Link to={'/super-admin/counsellor'} type="button" className="btn bg-light buttonadd"><IoArrowUndoSharp size={20} /> Back</Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AddCounceller;
